import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import CurrencyInput from '@core/components/currency-input/CurrencyInput.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(CurrencyInput.name, CurrencyInput)
